import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import List from '../List';
import './styles.css';

const messages = defineMessages({
  passwordRules: {
    id: 'common-password.passwordRules',
    defaultMessage: 'Passwords must contain at least 8 characters and must\ncontain a lowercase letter\ncontain an uppercase letter\ncontain a number\ncontain a special character (^ $ * . [ ] ( ) ? - " ! @ # % & / , > < \' : ; | _ ~ `)', // eslint-disable-line max-len
  },
});

function formatPasswordRules(nodes) {
  let key = 0;
  let firstValue;
  const children = nodes.reduce((result, node) => (
    result.concat(
      node
        .split('\n')
        .map((text, index) => {
          if (index===0) {
            firstValue = text;
            return '';
          }
          key += 1;
          return <List.Item as="li" value="&nbsp;&nbsp;-" key={key}>{text}</List.Item>;
        }),
    )
  ), []);

  return (
    <div>
      {firstValue}
      <List as="ol">
        {children}
      </List>
    </div>
  );
}

const PasswordRules = () => (
  <div styleName="rules">
    <FormattedMessage {...messages.passwordRules}>{formatPasswordRules}</FormattedMessage>
  </div>
);

export default PasswordRules;
